<template>
  <div class="col-md-12 mb-6">
    <label class="fs-6 fw-bold form-label mt-3">
      {{ attribute.label }} <span class="text-danger" v-if="attribute.required">*</span>
    </label>

    <div class="table-responsive">
      <table class="table table-bordered align-middle grid-input-table">
        <thead>
        <tr>
          <th style="min-width: 160px">Campo</th>
          <th v-for="column in columns" :key="column.key">{{ column.label }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in rows" :key="row.key">
          <td class="fw-semibold">{{ row.label }}</td>
          <td v-for="column in columns" :key="`${row.key}-${column.key}`">
            <AutoComplete
                v-if="isAutocompleteRow(row)"
                :modelValue="gridValues[row.key]?.[column.key] ?? ''"
                :suggestions="filteredSuggestions[`${row.key}-${column.key}`] ?? []"
                :dropdown="true"
                :disabled="disabled"
                class="w-100"
                @complete="searchSuggestions($event, row, column)"
                @update:modelValue="updateCell(row.key, column.key, $event)"
            />
            <input
                v-else
                type="text"
                class="form-control form-control-solid"
                :disabled="disabled"
                :value="gridValues[row.key]?.[column.key] ?? ''"
                @input="updateCell(row.key, column.key, $event.target.value)"
            >
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";

export default {
  name: "GridInput",
  components: {AutoComplete},
  emits: ['onChange'],
  props: {
    attribute: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      gridValues: {},
      filteredSuggestions: {},
    };
  },
  computed: {
    rows() {
      return this.attribute?.options?.rows ?? [];
    },
    columns() {
      return this.attribute?.options?.columns ?? [];
    },
  },
  created() {
    this.gridValues = this.parseAttributeValue();
  },
  watch: {
    'attribute.text': {
      handler() {
        this.gridValues = this.parseAttributeValue();
      },
    },
  },
  methods: {
    parseAttributeValue() {
      if (!this.attribute?.text) {
        return this.attribute?.options?.defaults ?? {};
      }

      if (typeof this.attribute.text === 'string') {
        try {
          return JSON.parse(this.attribute.text);
        } catch (_) {
          return {};
        }
      }

      return this.attribute.text;
    },
    isAutocompleteRow(row) {
      return ['autocomplete', 'autocomplete_strict'].includes(row?.cell_type);
    },
    searchSuggestions(event, row, column) {
      const key = `${row.key}-${column.key}`;
      const suggestions = Array.isArray(row?.suggestions) ? row.suggestions : [];
      const query = (event.query ?? '').toLowerCase();
      this.filteredSuggestions[key] = suggestions.filter((item) => item.toLowerCase().includes(query));
    },
    updateCell(rowKey, columnKey, value) {
      if (!this.gridValues[rowKey]) {
        this.gridValues[rowKey] = {};
      }

      this.gridValues[rowKey][columnKey] = value ?? '';

      this.$emit('onChange', {
        ...this.attribute,
        text: JSON.stringify(this.gridValues),
      });
    },
  },
};
</script>

<style scoped>
.grid-input-table td,
.grid-input-table th {
  vertical-align: middle;
}
</style>
